module.exports = __webpack_public_path__ + "img/speaker-1-1.a3ace9a6.jpg";